// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"qp-z","badgeLink":"rp-z","category":"sp-z"};